<script>
import i18n from "@/i18n";
import {mapActions, mapState} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import Skeleton from 'primevue/skeleton';
import MainSearchNoResults from "@/components/MainSearch/SearchResult/MainSearchNoResults.vue";
import ProposalListItem from "@/components/MainSearch/SearchResult/Proposal/ProposalListItem.vue";
import OpinionListItem from "@/components/MainSearch/SearchResult/Opinion/OpinionListItem.vue";
import ArgumentListItem from "@/components/MainSearch/SearchResult/Argument/ArgumentListItem.vue";
import MemberListItem from "@/components/MainSearch/SearchResult/MemberListItem.vue";
import OrganisationListItem from "@/components/MainSearch/SearchResult/OrganisationListItem.vue";
import ForumListItem from "@/components/MainSearch/SearchResult/ForumListItem.vue";
import SourceListItem from "@/components/MainSearch/SearchResult/SourceListItem.vue";

export default {
  name: "EverywhereListItem",
  props: {
    type: {
      type: String
    }
  },
  components: {
    Skeleton,
    MainSearchNoResults,
    ProposalListItem,
    OpinionListItem,
    ArgumentListItem,
    MemberListItem,
    OrganisationListItem,
    ForumListItem,
    SourceListItem,
  },
  computed: {
    ...mapState(mainSearchStore, [
      'searchParams',
      'searchAllResult'
    ]),
    searchResult() {
      return this.searchAllResult.find(list => list.type === this.type);
    },
    showMoreControlState() {
      return this.searchAllResult.find(list => list.type === this.type).showAllState;
    },
    label() {
      return i18n.global.t(`mainSearch.filters.${this.type.toLowerCase()}`);
    }
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'updateSearchParams'
    ]),
  }
}
</script>

<template>
  <div class="everywhere-list-item">
    <span class="search-type-label">{{ label }}:</span>
    <template v-if="searchResult.state">
      <template v-if="searchResult.result.length > 0">
        <template v-if="type === 'PROPOSAL'">
          <proposal-list-item v-for="item in searchResult.result"
                              :key="item.id"
                              :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'PROPOSAL')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
        <template v-else-if="type === 'OPINION'">
          <opinion-list-item v-for="item in searchResult.result"
                              :key="item.id"
                              :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'OPINION')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
        <template v-else-if="type === 'ARGUMENT'">
          <argument-list-item v-for="item in searchResult.result"
                              :key="item.id"
                              :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'ARGUMENT')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
        <template v-else-if="type === 'MEMBER'">
          <member-list-item v-for="item in searchResult.result"
                              :key="item.id"
                              :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'MEMBER')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
        <template v-else-if="type === 'ORGANIZATION'">
          <organisation-list-item v-for="item in searchResult.result"
                              :key="item.id"
                              :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'ORGANIZATION')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
        <template v-else-if="type === 'FORUM'">
          <forum-list-item v-for="item in searchResult.result"
                                  :key="item.id"
                                  :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'FORUM')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
        <template v-else-if="type === 'SOURCE'">
          <source-list-item v-for="item in searchResult.result"
                           :key="item.id"
                           :item-data="item"
          />
          <span v-if="showMoreControlState" class="show-more" @click="updateSearchParams('searchType', 'SOURCE')">
            {{$t('mainSearch.seeMoreResults')}}
          </span>
        </template>
      </template>
      <template v-else>
        <main-search-no-results :search-string="searchParams.searchString"/>
      </template>
    </template>
    <template v-else>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.everywhere-list-item {
  margin-bottom: 20px;
  .search-type-label {
    display: inline-block;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
  }
  .show-more {
    padding-top: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #7835a6;
    cursor: pointer;
  }
}

</style>